// extracted by mini-css-extract-plugin
export default {"container":"GibI","divider":"JB8Q","wrapper":"cVHJ","btnWrapper":"wtel"};